import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;


export const getAllCountries = async () => {
    try {
      const response = await axios.get(`${apiUrl}/static/getAllCountry`);
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  };

  export const getAllQualifications = async () => {
    try {
      const response = await axios.get(`${apiUrl}/static/getAllQualificationList`);
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  };
  

  export const getAllCitys = async (countryId) => {
    try {
      const response = await axios.get(`${apiUrl}/static/getCityByCountryId/${countryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching citys:', error);
      throw error;
    }
  };
  export const getAllOccupations = async () => {
    try {
      const response = await axios.get(`${apiUrl}/static/getAllOccupationList`);
      return response.data;
    } catch (error) {
      console.error('Error fetching OccupationList:', error);
      throw error;
    }
  };

  export const getAllCategory = async () => {
    try {
      const response = await axios.get(`${apiUrl}/static/getAllCategory`);
      return response.data;
    } catch (error) {
      console.error('Error fetching CategoryList:', error);
      throw error;
    }
  };

  export const getSubCategory = async () => {
    try {
      const response = await axios.get(`${apiUrl}/static/getAllSubcategory`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sub CategoryList:', error);
      throw error;
    }
  };

  export const getAllSubCategory = async (categoryId) => {
    try {
      const response = await axios.get(`${apiUrl}/static/getSubcategoryByCatId/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching SubCategoryList', error);
      throw error;
    }
  };

  export const createReport = async (formdata)=> {
    try{
      const response = await axios.post(`${apiUrl}/report/createReport`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating report:', error);
      throw error;
    }
  };
